import { BillingData, BillingState } from '@/types/billing';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: BillingState = {
  billingsData: {
    totalPages: 0,
    page: 1,
    data: [],
    sortKey: 'created_at',
    sortDirection: 'desc',
  },
  billingPlans: [],
};

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setBillingData: (state, action: PayloadAction<BillingData>) => {
      state.billingsData = action.payload;
    },
    setBillingPlans: (state, action: PayloadAction<any[]>) => {
      state.billingPlans = action.payload;
    },
    setBillingPageAction: (state, action: PayloadAction<number>) => {
      state.billingsData.page = action.payload;
    },
    setBillingSortAction: (state, action: PayloadAction<{ sortKey: string; sortDirection: 'asc' | 'desc' }>) => {
      state.billingsData.sortKey = action.payload.sortKey;
      state.billingsData.sortDirection = action.payload.sortDirection;
    },
  },
});

export const { setBillingData, setBillingPlans, setBillingPageAction, setBillingSortAction } = billingSlice.actions;

export default billingSlice.reducer;
